import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'

const useStyles = makeStyles(errorStyles)

export default function Error ({error, question, context}) {

  const classes = useStyles()

  const {translate} = context 

  return typeof(error) == 'string'
    ? (<Box className={classes.error}>{translate(error, question)}</Box>)
    : (<React.Fragment>{
        error(question, context).map((message, index) => (
          <Box key={index} className={classes.error}>
            {message}
          </Box>
        ))}
      </React.Fragment>)
}

function errorStyles(theme) {

  return {
    error: {
      marginTop: 5,
      color: 'red',
      fontSize: '11pt',
      fontStyle: 'italic',
      "&:first-child": {
        marginTop: 0
      }
    }
  }
}


